/**
 * @description 保险保单状态
 *
 */
export const policy_state = {
  10: "已出单",
  20: "保障中",
  30: "判赔中",
  40: "未发生理赔",
  41: "判赔成功",
  50: "理赔成功",
};

/**
 * @description 保险订单状态
 *
 */

export const order_state = {
  10: "未支付",
  20: "已支付",
  30: "已关闭",
  40: "出单中",
};

/**
 * @description 保险支付方式
 *
 */

export const pay_state = {
  0: "线下支付",
  1: "线上支付",
};

/**
 * @description 投保人信息证件类型
 *
 */

export const identify_type = {
  "01": "身份证",
  "03": "护照",
  70: "营业执照信用代码",
};
/**
 * @description 客户类型
 *
 */

export const appli_type = {
  1: "个人",
  2: "单位",
};

/**
 * @description 灾害申报状态
 *
 */
export const damage_report_status = {
  0: "申报未开始",
  1: "可申报",
  2: "申报截止",
};
/**
 * @description 灾害类型
 *
 */
export const damage_type = {
  1: "冷害",
  2: "风害",
  3: "干旱",
  4: "霜冻",
  5: "涝害",
  6: "热害",
};
/**
 * @description 栽培类型
 *
 */
export const cultivation_type = {
  FACILITIES: "设施",
  OPEN: "露地",
};
/**
 * @description 受灾程度
 *
 */
export const damage_level = {
  SMALL: "受灾",
  MEDIUM: "成灾",
  LARGE: "绝收",
};
/**
 * @description 受灾程度
 *
 */
export const process_status = {
  0: "未审核",
  1: "审核通过",
  2: "审核拒绝",
};

/**
 * @description 合格证类型
 *
 */
export const certificate_type = {
  1: "地产型合格证",
  2: "采购型合格证",
  3: "市场型合格证",
};

/**
 * @description 合格证模板映射关系
 *
 */
export const hgzTemplateMapComName = {
  hgzys3: "shhgz", // 上海合格证模板
  hgzys4: "shhgz",
  hgzys5: "shhgz",
  hgzys6: "shhgz",
  jyhgzsh: "shhgz",
  jydlbzhgz: "jyhgz", // 旌阳合格证模板
  dcpthgz: "shhgzdcpt", // 上海合格证地产普通
  dclshgz1: "shhgzdccs", // 地产型绿色认证合格证彩色
  dclshgz2: "shhgzdchs", // 地产型绿色认证合格证黑白
  wchgz: "shhgzwc", // 地产型绿色认证合格证外采
  schgz: "shhgzsc", // 地产型绿色认证合格证市场
  dcpthgz2026: "dcpthgz2026",
  dclshgz12026: "dclshgz12026",
  dclshgz22026: "dclshgz22026",
  cgpthgz2026: "cgpthgz2026",
  cglshgz12026: "cglshgz12026",
  cglshgz22026: "cglshgz22026",
  schgz2026: "schgz2026", // 市场型合格证2026
};
